import React, { useState } from "react";
import logo from "./img/edaplogo.png";
import View from "./appercu";
import Gen from "./generate";

function Card() {
  const [activeTab, setActiveTab] = useState("generate");
  const [formData, setFormData] = useState({
    name: "",
    faculty: "",
    department: "",
    class: "",
    matricule: "",
    year: "",
  });
  const [students, setStudents] = useState([]);

    return (
    <div className="card_section">
      <div>
        <button
          className={activeTab === "generate" ? "m-tab active" : "m-tab"}
          onClick={() => setActiveTab("generate")}
        >
          Générer
        </button>
        <button
        id="view_tab"
          className={activeTab === "view" ? "m-tab active" : "m-tab"}
          onClick={() => setActiveTab("view")}
        >
          Apperçu
        </button>
        <div className="m-tab-content">
          {activeTab === "generate" && (
            <div className="content-form">
              <Gen/>
            </div>
          )}
          {activeTab === "view" && (
            <div className="content-form">
              <View students={students} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Card;
